import React, { Suspense, lazy } from "react";
import "./Hero.css";
import { personalInfo } from "../data/portfolioData";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiMail, HiDownload, HiLocationMarker, HiArrowNarrowRight } from "react-icons/hi";

// Lazy load the Avatar component so it never blocks the critical rendering path or first paint
const Avatar = lazy(() => import("./Avatar/Avatar"));

function Hero() {
  return (
    <section id="hero" className="hero-section">
      <div className="container hero-container">
        <div className="hero-grid">
          {/* Left Column: Talking 3D Avatar (Lazy-Loaded) */}
          <div className="hero-avatar-wrapper">
            <Suspense
              fallback={
                <div className="avatar-loading-skeleton" aria-label="Loading interactive avatar">
                  <div className="skeleton-circle"></div>
                  <div className="skeleton-pill"></div>
                  <p>Loading 3D Interactive Avatar...</p>
                </div>
              }
            >
              <Avatar />
            </Suspense>
          </div>

          {/* Right Column: Core Credibility & Profile Narrative */}
          <div className="hero-narrative">
            <div className="hero-location-badge">
              <HiLocationMarker size={16} />
              <span>{personalInfo.location}</span>
            </div>

            <h1 className="hero-name">{personalInfo.name}</h1>

            <h2 className="hero-headline">{personalInfo.headline}</h2>

            <p className="hero-summary-lead">{personalInfo.summary}</p>

            {/* Quick Action Buttons */}
            <div className="hero-actions">
              <a
                href={personalInfo.links.resume}
                download="Prasanna_Kumar_Resume.pdf"
                className="btn btn-primary hero-btn-main"
                aria-label="Download Prasanna Kumar Resume PDF"
              >
                <HiDownload size={18} />
                <span>Download Resume</span>
              </a>

              <a href="#experience" className="btn btn-secondary hero-btn-sub">
                <span>View Engineering Experience</span>
                <HiArrowNarrowRight size={18} />
              </a>
            </div>

            {/* Direct Contact Links */}
            <div className="hero-connect-row">
              <span className="connect-label">Connect:</span>
              <div className="connect-links">
                <a
                  href={personalInfo.links.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="connect-item"
                  aria-label="LinkedIn profile"
                >
                  <FaLinkedin size={18} />
                  <span>LinkedIn</span>
                </a>

                <a
                  href={personalInfo.links.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="connect-item"
                  aria-label="GitHub profile"
                >
                  <FaGithub size={18} />
                  <span>GitHub</span>
                </a>

                <a
                  href={`mailto:${personalInfo.links.email}`}
                  className="connect-item"
                  aria-label="Email Prasanna Kumar"
                >
                  <HiMail size={18} />
                  <span>{personalInfo.links.email}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
